<template>
  <div class="a-upload-icon">
    <div class="single">
      <el-upload :action="action" :list-type="listType" :auto-upload="autoUpload" :limit="Number(limit)" :file-list="list" :showFileList="multiple && showFileList" :http-request="change"
        :on-change="change" :on-remove="remove">
        <div class="icon">
          <img v-if="link && link != '' && link != undefined && link != 'undefined'" :src="link" class="icon" />
          <i v-else class="el-icon-plus" />
        </div>
      </el-upload>
      <div v-if="link" class="delete" @click="remove">
        <i class="el-icon-delete-solid" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuploadIcon',
  props: {
    src: null,
    url: { type: String, default: () => '' },
    type: { type: String, default: () => 'image' },
    action: { type: String, default: () => '#' },
    multiple: { type: Boolean, default: () => false },
    size: { type: String, default: () => '2m' },
    listType: { type: String, default: () => 'picture-card' },
    autoUpload: { type: Boolean, default: () => false },
    fileList: { type: Array, default: () => [] },
    showFileList: { type: Boolean, default: () => false },
    limit: { type: String, default: () => '10' },
    removeMark: { type: String, default: () => 'will-remove' },
  },
  data() {
    return {
      list: [],
      link: '',
      defaultUrl: null,
    }
  },
  watch: {
    src() {
      this.update();
    },
    link() {
      this.update();
    }
  },
  created() {
    this.create();
    this.update();
  },
  methods: {
    create() {
      if (this.multiple) {
        this.list = this.fileList.concat(this.list);
      } else {
        this.defaultUrl = this.src;
      }
    },
    update() {
      if (this.multiple) {
        this.list = this.fileList.concat(this.list);
      } else {
        if (this.src && this.src.url && !this.src.url.includes(this.removeMark) || this.src && !this.src.includes(this.removeMark)) {
          this.link = this.src && this.src.url || this.src;
        }
      }
    },
    change(file = {}, list = []) {
      if (this.multiple) {
        this.$emit('change', list);
      } else {
        if ((file.size / 1024) > (parseInt(this.size) * 1024)) {
          this.$message.info(`上传文件超过了${this.size}限制`);
          return false;
        } else {
          if (file && file.url) {
            const { url, raw } = file;
            this.link = url;
            const params = Object.assign(raw, { url, old: this.removeMark + '=' + this.defaultUrl });
            this.$nextTick(() => {
              this.$emit('input', params);
              this.$nextTick(() => this.$emit('change', params));
            });
          }
        }
      }
    },
    remove() {
      this.$emit('remove');
      this.$nextTick(() => {
        this.$emit('input', this.removeMark + '=' + this.defaultUrl);
        this.$nextTick(() => this.link = '');
      });
    },
  },
}
</script>

<style scoped>
@import "index.css";
</style>